module.exports = __webpack_public_path__ + "img/slider-boxer-product.17fb0f09.webp";